import { Button } from '@zoom/react-ui'
import LockIcon from '../icons/Lock'
import { selectApp } from '../app/root'
import {
  useAppSelector,
  useSelectAuth,
  useSelectSharerScreenName,
} from '../hooks'
import { useCreateFilePermissionMutation } from '../app/appApiQueries'
import { Auth } from '../app/auth'

const ShareEmail = () => {
  const app = useAppSelector(selectApp)!
  const auth = useSelectAuth(app)!
  const email = (auth as Auth)?.thirdPartyUserInfo?.email
  const sharerScreenName = useSelectSharerScreenName(app)
  const [createPermission] = useCreateFilePermissionMutation()

  const handleConfirm = async () => {
    await createPermission(app)
  }

  const handleDecline = async () => {
    try {
      await zoomSdk.leaveCollaborate() // automatically send the page back to home when leaving collaborate mode
      await zoomSdk.sendAppToBackground()
    } catch {
      // swallow
    }
  }

  return (
    <div className='flex h-screen items-center justify-center px-4 md:px-10'>
      <div className='flex w-full max-w-[800px] flex-col items-center'>
        <LockIcon className='h-14 w-[53px]' />
        <h1 className='mt-4 text-base font-[590]'>
          Share email to gain access
        </h1>
        <p className='mt-2 text-center text-sm font-normal text-[#6E7680]'>
          To join collaboration, your email address {email} will be shared with{' '}
          {sharerScreenName}.
        </p>

        <div className='mt-6 flex items-center gap-2'>
          <Button
            autoLoading
            onClick={handleConfirm}
          >
            Confirm
          </Button>
          <Button
            autoLoading
            onClick={handleDecline}
            type='secondary'
          >
            Decline
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ShareEmail
